import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonPaginationComponent } from '../common-component-pagination/common-component-pagination.component';
import { CommonSearchComponent } from '../common-component-search/common-component-search.component';
import { CommonApiService } from '../CommonController/common-api-service';
import { governmentServerApiServer } from '../CommonController/governmentServer-api-service';
@Component({
  selector: 'app-govt-servers-page',
  templateUrl: './govt-servers-page.component.html',
  styleUrls: ['./govt-servers-page.component.scss'],
  standalone: true,
  imports: [
    MatIcon,
    CommonSearchComponent,
    FormsModule,
    ReactiveFormsModule,
    CommonPaginationComponent,
  ],
})
export class GovtServersPageComponent implements OnInit {
  // Pagination settings
  pageSize = 10; // Number of items per currentPage
  currentPage = 1; // Current currentPage
  searchText = ''; // Search text

  // Data arrays
  displayedItems = []; // List of items displayed on the current currentPage
  totalItems = 0; // Total number of items (for pagination purposes)
  totalPages = 0; // Total number of items (for pagination purposes)

  // Form group for handling the form
  govtServersForm: FormGroup;

  // User-related data
  loggedInUserId = null; // Logged in user ID (could be null or string)
  userRole = ''; // Role of the logged-in user (e.g., 'support', 'manager')
  userPermissions = []; // User permissions object

  // Permissions related to gov servers
  canViewGovServers = false;
  canCreateGovServers = false;
  canUpdateGovServers = false;
  canDeleteGovServers = false;
  canViewFirmwareMaster = false;

  constructor(
    public governmentServerApiServer: governmentServerApiServer,
    public commonApiService: CommonApiService,
    private formBuilder: FormBuilder,
    public router: Router,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.checkPermission();
    this.setGovtForm();
    this.fetchGovtServerList();
  }

  checkPermission() {
    this.userPermissions = JSON.parse(
      sessionStorage.getItem('userPermissions')
    );
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.userPermissions.forEach((element) => {
      if (element.pageName === 'Government Servers' && element.view === false) {
        this.navigateBack();
      }
      if (element.pageName === 'Government Servers' && element.view === true) {
        this.canViewGovServers = true;
      }
      if (
        element.pageName === 'Government Servers' &&
        element.create === true
      ) {
        this.canCreateGovServers = true;
      }
      if (
        element.pageName === 'Government Servers' &&
        element.update === true
      ) {
        this.canUpdateGovServers = true;
      }
      if (
        element.pageName === 'Government Servers' &&
        element.delete === true
      ) {
        this.canDeleteGovServers = true;
      }

      if (element.pageName === 'Firmware Master' && element.view === true) {
        this.canViewFirmwareMaster = true;
      }
    });
  }

  setGovtForm() {
    this.govtServersForm = this.formBuilder.group({
      myActivationsSearch: new FormControl(''),
    });
  }
  fetchGovtServerList() {
    this.spinner.show();
    this.governmentServerApiServer
      .getGovtServerList(
        this.currentPage - 1,
        this.pageSize,
        this.searchText,
        this.loggedInUserId
      )
      .subscribe({
        next: (res) => {
          this.spinner.hide();
          if (res.status) {
            this.displayedItems = res.data;
            this.totalItems = res.totalItems;
            this.totalPages = res.totalPages;
            this.commonApiService.openSnackbar(res.message);
          } else {
            this.displayedItems = [];
            this.totalItems = 0;
            this.totalPages = 0;
            this.commonApiService.openSnackbar(res.message);
          }
        },
        error: (error: HttpErrorResponse) => {
          this.displayedItems = [];
          this.totalItems = 0;
          this.totalPages = 0;
          this.spinner.hide();
          this.commonApiService.openSnackbar(error.error.message);
        },
      });
  }

  onSearchInputChange(event) {
    this.currentPage = 1;
    this.searchText = event;
    this.fetchGovtServerList();
  }

  deleteGovtServer(stateServerId) {
    if (confirm('Are you sure to Delete')) {
      this.spinner.show();
      this.governmentServerApiServer
        .deleteGovtServer(stateServerId, this.loggedInUserId)
        .subscribe({
          next: (res) => {
            if (res.status) {
              this.ngOnInit();
              this.commonApiService.openSnackbar(res.message);
            } else {
              this.commonApiService.openSnackbar(res.message);
            }
          },
          error: (ERROR: HttpErrorResponse) => {
            this.commonApiService.openSnackbar(ERROR.error.message);
          },
        });
    }
  }

  onPageChange(event) {
    this.currentPage = event;
    this.fetchGovtServerList();
  }

  onSizeChange(pageSize): void {
    this.pageSize = pageSize; // Update the pageSize
    this.currentPage = 1; // Reset to the first currentPage
    this.fetchGovtServerList();
  }

  AddNew() {
    this.router.navigate(['govt-servers-add']);
  }

  viewGSDetails(id): void {
    this.router.navigate(['govt-servers-add', id]);
  }

  redirect(to): void {
    this.router.navigate([to]);
  }

  navigateBack() {
    this.commonApiService.back();
  }
}
